export default __webpack_public_path__ + "static/media/ai_LEDActive.18cf6552.svg";